import React, { useState, useEffect } from 'react';
import { X, Shield } from 'lucide-react';

const CONSENT_KEY = 'cookie-consent';

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      setShow(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setShow(false);
    // Reload to initialize analytics
    window.location.reload();
  };

  const handleDecline = () => {
    localStorage.setItem(CONSENT_KEY, 'declined');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50">
      <div className="max-w-7xl mx-auto p-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <Shield className="h-5 w-5 text-teal-600 flex-shrink-0" />
            <p className="text-sm text-gray-600">
              We use anonymous analytics cookies to understand how you use our site and improve your experience. 
              Your data is never stored or shared.
            </p>
          </div>
          <div className="flex items-center gap-4">
            <button
              onClick={handleDecline}
              className="text-sm text-gray-500 hover:text-gray-700"
            >
              Decline
            </button>
            <button
              onClick={handleAccept}
              className="px-4 py-2 bg-teal-600 text-white text-sm font-medium rounded-lg hover:bg-teal-700"
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}